// 预发布和正式
export const prEnvironment = process.env.NEXT_PUBLIC_BUILD_TYPE.includes('build:pr');
// 正式
export const proEnvironment = process.env.NEXT_PUBLIC_BUILD_TYPE === 'build:pro';
